import { Webhook } from "lucide-react";
import { useTranslation } from "react-i18next";

import { useWebhookSubscriptions } from "../api/useWebhookSubscriptions";
import { useWebhookSubscriptionColumns } from "../hooks/useWebhookSubscriptionColumns";

import { DataTable } from "@/components/ui/v2/table/data-table";
import { usePageSearchParams } from "@/lib/hooks/usePageSearchParams";
import { usePageSizeSearchParams } from "@/lib/hooks/usePageSizeSearchParams";
import {
  useSortSearchParams,
  useTableSortHandler,
} from "@/lib/hooks/useSortSearchParams";

interface WebhookSubscriptionsContentProps {
  integrationId?: string | null;
}

export function WebhookSubscriptionsContent({
  integrationId,
}: WebhookSubscriptionsContentProps) {
  const { t } = useTranslation();
  const { orderBy, descending } = useSortSearchParams();
  const handleSort = useTableSortHandler();
  const { page, setPage } = usePageSearchParams();
  const { pageSize, setPageSize } = usePageSizeSearchParams();

  const { data, isLoading, isFetching } = useWebhookSubscriptions({
    integrationId,
    page,
    pageSize,
    orderBy: orderBy ?? undefined,
    descending: descending ?? undefined,
  });

  const columns = useWebhookSubscriptionColumns();

  return (
    <div className="space-y-6">
      <DataTable
        columns={columns}
        data={data?.data ?? []}
        isLoading={isLoading || isFetching}
        onSort={handleSort}
        orderBy={orderBy ?? undefined}
        descending={descending ?? undefined}
        page={page}
        pageSize={pageSize}
        totalRecords={data?.totalRecords ?? 0}
        onPageChange={setPage}
        onPageSizeChange={setPageSize}
        getRowId={(item) => item.id}
        emptyState={{
          icon: Webhook,
          title: t("webhooks.subscriptions.noSubscriptions"),
          description: t("webhooks.subscriptions.noSubscriptionsDescription"),
        }}
      />
    </div>
  );
}
